'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

interface UseScrollToTopOptions {
    /** scrolls when isLoading is false (ie loading is complete) */
    isLoading?: boolean;
    /** if onOrderChange true, order change will trigger scroll event */
    order?: { id?: string | number } | null;
    /** boolean that allows scroll on order change */
    onOrderChange?: boolean;
}

/**
 * Hook that scrolls to the top of the page when the route changes or when
 * custom dependencies change. This ensures that when navigating between pages,
 * the new page loads at the top instead of maintaining the previous scroll position.
 *
 * @param isLoading scrolls when isLoading is false (ie loading is complete)
 * @param onOrderChange boolean that allows scroll on order change
 * @param order if onOrderChange true, order change will trigger scroll event
 */
export function useScrollToTop({ isLoading, order, onOrderChange }: UseScrollToTopOptions) {
    const pathname = usePathname();

    useEffect(() => {
        // PLP scroll to grid check (with hash)
        // src/product-listing-page/src/components/ProductGrid/ProductGrid.tsx
        const hasTabs1Hash = window.location.hash === '#tabs-1';

        if (isLoading || (onOrderChange && !order) || hasTabs1Hash) {
            return;
        }

        requestAnimationFrame(() => {
            window.scrollTo({ top: 0, behavior: 'instant' });
        });
    }, [pathname, isLoading, order?.id]);
}
